angular.module('webtrader').component('cubic', {
  bindings: {
    quote: '=',
  },
  templateUrl: BASE_URL+'templates/component.cubic.html',
  controller: function (Account, Quotes, Trades) {
    this.quotes = Quotes
    this.volume = 1

    this.inc = (val, add) => (typeof val !== 'number' || isNaN(val))? Math.abs(add) : Math.max((val + add).toFixed(2), Math.abs(add))

    this.buy = () => this.openTrade(0)
    this.sell = () => this.openTrade(1)

    this.openTrade = (cmd) => {
      Trades.order({
        cmd: cmd,
        symbol: this.quote.symbol,
        volume: this.volume
      })
    }
  }
})
